(function () {
  document.documentElement.classList.remove('no-js');
  var CART_RESERVATION_MS = 300000;

  function formatMoney(cents, format, currencyCode) {
    var value = Number(cents || 0);
    var template = format || '${{amount}}';
    var token = (template.match(/\{\{\s*(\w+)\s*\}\}/) || [null, 'amount'])[1];
    var amount;

    if (token === 'amount_no_decimals') {
      amount = Math.round(value / 100).toLocaleString();
    } else if (token === 'amount_with_comma_separator') {
      amount = (value / 100).toFixed(2).replace('.', ',');
    } else if (token === 'amount_no_decimals_with_comma_separator') {
      amount = Math.round(value / 100).toLocaleString('de-DE');
    } else {
      amount = (value / 100).toFixed(2);
    }

    var output = template.replace(/\{\{\s*\w+\s*\}\}/, amount);
    var code = String(currencyCode || '').toUpperCase();
    var ambiguousDollarCurrencies = ['CAD', 'AUD', 'NZD', 'SGD', 'HKD', 'MXN', 'ARS', 'CLP', 'COP', 'TWD'];
    if (ambiguousDollarCurrencies.indexOf(code) !== -1 && output.indexOf(code) === -1) {
      output = output.indexOf('$') !== -1 ? output.replace('$', code + '$') : code + ' ' + output;
    }
    return output;
  }

  function storeRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function updateCartCounts(cart) {
    document.querySelectorAll('[data-cart-count]').forEach(function (count) {
      count.textContent = cart && Number.isFinite(Number(cart.item_count)) ? cart.item_count : 0;
    });
  }

  function resetCartReservation() {
    try { window.sessionStorage.setItem('annasCartReservationEnd', String(Date.now() + CART_RESERVATION_MS)); } catch (error) {}
  }

  function reservationEnd() {
    var value = 0;
    try { value = Number(window.sessionStorage.getItem('annasCartReservationEnd') || 0); } catch (error) {}
    if (!value || value <= Date.now() || value > Date.now() + CART_RESERVATION_MS) {
      resetCartReservation();
      value = Date.now() + CART_RESERVATION_MS;
    }
    return value;
  }

  function queueCartOpenAfterReload() {
    try { window.sessionStorage.setItem('annasOpenCartAfterReload', 'true'); } catch (error) {}
  }

  function consumeCartOpenAfterReload() {
    var shouldOpen = false;
    try {
      shouldOpen = window.sessionStorage.getItem('annasOpenCartAfterReload') === 'true';
      window.sessionStorage.removeItem('annasOpenCartAfterReload');
    } catch (error) {}
    return shouldOpen;
  }

  function startCartTimer(drawer) {
    var output = drawer.querySelector('[data-cart-timer]');
    if (!output) return;
    window.clearInterval(drawer._annaCartTimer);
    var end = reservationEnd();

    function renderTimer() {
      var remaining = Math.max(0, Math.ceil((end - Date.now()) / 1000));
      var minutes = Math.floor(remaining / 60);
      var seconds = remaining % 60;
      output.textContent = String(minutes).padStart(2, '0') + ':' + String(seconds).padStart(2, '0');
      if (remaining <= 0) {
        window.clearInterval(drawer._annaCartTimer);
        try { window.sessionStorage.removeItem('annasCartReservationEnd'); } catch (error) {}
      }
    }

    renderTimer();
    drawer._annaCartTimer = window.setInterval(renderTimer, 1000);
  }

  function currentCartDrawer() {
    return document.querySelector('[data-cart-drawer]');
  }

  function openAnnaCart() {
    var drawer = currentCartDrawer();
    if (!drawer) return;
    var wasOpen = drawer.classList.contains('isOpen');
    if (!wasOpen) drawer._annaPreviousFocus = document.activeElement;
    drawer.classList.add('isOpen');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cartDrawerOpen');
    document.documentElement.classList.add('cartDrawerOpen');
    startCartTimer(drawer);
    if (!wasOpen) window.setTimeout(function () {
      var panel = drawer.querySelector('.annaCartPanel');
      if (panel) panel.focus({ preventScroll: true });
    }, 40);
  }

  function closeAnnaCart() {
    var drawer = currentCartDrawer();
    if (!drawer) return;
    drawer.classList.remove('isOpen');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cartDrawerOpen');
    document.documentElement.classList.remove('cartDrawerOpen');
    window.clearInterval(drawer._annaCartTimer);
    if (drawer._annaPreviousFocus && drawer._annaPreviousFocus.focus) drawer._annaPreviousFocus.focus({ preventScroll: true });
  }

  function renderCartDrawerSection(sectionHtml, openAfter) {
    var container = document.getElementById('shopify-section-annas-cart-drawer');
    if (!container) throw new Error('Cart drawer section was not found.');
    if (!sectionHtml) throw new Error('Cart drawer could not be rendered.');
    var previousDrawer = currentCartDrawer();
    var wasOpen = previousDrawer && previousDrawer.classList.contains('isOpen');
    var previousItems = previousDrawer && previousDrawer.querySelector('[data-cart-items]');
    var scrollPosition = previousItems ? previousItems.scrollTop : 0;
    var returnFocus = previousDrawer && previousDrawer._annaPreviousFocus;
    var activeControl = document.activeElement;
    var activeItem = activeControl && activeControl.closest('[data-cart-key]');
    var activeKey = activeItem && activeItem.dataset.cartKey;
    var activeDelta = activeControl && activeControl.dataset.cartDelta;

    var parsed = new DOMParser().parseFromString(sectionHtml, 'text/html');
    var renderedSection = parsed.getElementById('shopify-section-annas-cart-drawer');
    var renderedDrawer = parsed.querySelector('[data-cart-drawer]');
    if (!renderedSection && !renderedDrawer) throw new Error('Cart drawer could not be rendered.');

    container.innerHTML = renderedSection ? renderedSection.innerHTML : renderedDrawer.outerHTML;
    initializeCartDrawer(container);
    var newDrawer = currentCartDrawer();
    if (newDrawer && wasOpen) {
      newDrawer._annaPreviousFocus = returnFocus;
      newDrawer.classList.add('isOpen');
      var newItems = newDrawer.querySelector('[data-cart-items]');
      if (newItems) newItems.scrollTop = scrollPosition;
      var newItem = Array.from(newDrawer.querySelectorAll('[data-cart-key]')).find(function (item) { return item.dataset.cartKey === activeKey; });
      var newControl = newItem && Array.from(newItem.querySelectorAll('[data-cart-delta]')).find(function (button) { return button.dataset.cartDelta === activeDelta; });
      if (!newControl) newControl = newDrawer.querySelector('.annaCartPanel');
      if (newControl) newControl.focus({ preventScroll: true });
    }
    if (openAfter) openAnnaCart();
  }

  function refreshAnnaCart(openAfter) {
    return fetch(storeRoot() + '?section_id=annas-cart-drawer', {
      headers: { 'Accept': 'text/html' }
    }).then(function (response) {
      if (!response.ok) throw new Error('Unable to refresh your cart.');
      return response.text();
    }).then(function (sectionHtml) {
      renderCartDrawerSection(sectionHtml, openAfter);
    });
  }

  function cartMessage(drawer, text) {
    var error = drawer.querySelector('[data-cart-error]');
    if (error) error.textContent = text || '';
  }

  function updateCartItems(drawer, updates, openAfter) {
    cartMessage(drawer, '');
    drawer.classList.add('isLoading');
    var cartChanged = false;

    return fetch(storeRoot() + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        updates: updates,
        sections: ['annas-cart-drawer'],
        sections_url: window.location.pathname
      })
    }).then(function (response) {
      if (!response.ok) return response.json().then(function (body) { throw new Error(body.description || 'Unable to update your cart.'); });
      return response.json();
    }).then(function (cart) {
      cartChanged = true;
      updateCartCounts(cart);
      if (cart.sections && cart.sections['annas-cart-drawer']) {
        renderCartDrawerSection(cart.sections['annas-cart-drawer'], openAfter);
        return;
      }
      return refreshAnnaCart(openAfter);
    }).catch(function (error) {
      drawer.classList.remove('isLoading');
      cartMessage(drawer, cartChanged ? 'Your cart was updated, but the panel could not refresh. Please close and reopen it.' : (error.message || 'Please try again.'));
    });
  }

  function orphanAddOnUpdates(drawer) {
    if (drawer.querySelector('[data-cart-role="toy"]')) return null;
    var updates = {};
    drawer.querySelectorAll('[data-cart-role="addon"][data-cart-key]').forEach(function (item) {
      updates[item.dataset.cartKey] = 0;
    });
    return Object.keys(updates).length ? updates : null;
  }

  function removeOrphanAddOns(drawer, openAfter) {
    var updates = orphanAddOnUpdates(drawer);
    if (!updates) return null;
    return updateCartItems(drawer, updates, openAfter);
  }

  function changeCartLine(drawer, line, quantity) {
    var targetItem = Array.from(drawer.querySelectorAll('[data-cart-role][data-cart-line]')).find(function (item) {
      return item.dataset.cartLine === String(line);
    });
    var toyItems = drawer.querySelectorAll('[data-cart-role="toy"]');

    if (Number(quantity) === 0 && targetItem && targetItem.dataset.cartRole === 'toy' && toyItems.length === 1) {
      var dependentUpdates = {};
      if (targetItem.dataset.cartKey) dependentUpdates[targetItem.dataset.cartKey] = 0;
      drawer.querySelectorAll('[data-cart-role="addon"][data-cart-key]').forEach(function (item) {
        dependentUpdates[item.dataset.cartKey] = 0;
      });
      if (Object.keys(dependentUpdates).length) return updateCartItems(drawer, dependentUpdates, true);
    }

    cartMessage(drawer, '');
    drawer.classList.add('isLoading');
    var cartChanged = false;
    var requestBody = {
      line: Number(line),
      quantity: Number(quantity),
      sections: ['annas-cart-drawer'],
      sections_url: window.location.pathname
    };

    return fetch(storeRoot() + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(requestBody)
    }).then(function (response) {
      if (!response.ok) return response.json().then(function (body) { throw new Error(body.description || 'Unable to update your cart.'); });
      return response.json();
    }).then(function (cart) {
      cartChanged = true;
      updateCartCounts(cart);
      if (cart.sections && cart.sections['annas-cart-drawer']) {
        renderCartDrawerSection(cart.sections['annas-cart-drawer'], true);
        return;
      }
      return refreshAnnaCart(true);
    }).catch(function (error) {
      drawer.classList.remove('isLoading');
      cartMessage(drawer, cartChanged ? 'Your cart was updated, but the panel could not refresh. Please close and reopen it.' : (error.message || 'Please try again.'));
    });
  }

  function cartItemColor(item) {
    var properties = item && item.properties ? item.properties : {};
    var color = properties['_Toy style'] || properties['Toy style'];
    if (color) return String(color);
    if (item && item.variant_title && item.variant_title !== 'Default Title') return String(item.variant_title);
    return '';
  }

  function cartItemIsAddOn(item) {
    var properties = item && item.properties ? item.properties : {};
    return Boolean(properties['_Ruff add-on']) || item.handle === 'shipping-protection' || item.handle === 'priority-shipping';
  }

  function cartItemIsToy(item) {
    var properties = item && item.properties ? item.properties : {};
    return !cartItemIsAddOn(item) && (Boolean(properties['_Toy style'] || properties['Toy style']));
  }

  function postCartChange(root, line, quantity, includeSections) {
    var body = { line: Number(line), quantity: Number(quantity) };
    if (includeSections) {
      body.sections = ['annas-cart-drawer'];
      body.sections_url = window.location.pathname;
    }
    return fetch(root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (response) {
      if (!response.ok) return response.json().then(function (result) { throw new Error(result.description || 'Unable to update your cart.'); });
      return response.json();
    });
  }

  function postCartAdd(root, items) {
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        items: items,
        sections: ['annas-cart-drawer'],
        sections_url: window.location.pathname
      })
    }).then(function (response) {
      if (!response.ok) return response.json().then(function (result) { throw new Error(result.description || 'Unable to add these items.'); });
      return response.json();
    });
  }

  function addOrIncrementCartItems(root, requestedItems) {
    var finalResult = null;

    return fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' } }).then(function (response) {
      if (!response.ok) throw new Error('Unable to check your cart.');
      return response.json();
    }).then(function (cart) {
      var cartHasToy = cart.items.some(cartItemIsToy);
      var requestHasToy = requestedItems.some(function (item) {
        return Boolean(item.properties && (item.properties['_Toy style'] || item.properties['Toy style']));
      });
      requestedItems = requestedItems.filter(function (item) {
        var isAddOn = Boolean(item.properties && item.properties['_Ruff add-on']);
        return !isAddOn || cartHasToy || requestHasToy;
      });

      var changes = [];
      var additions = [];

      requestedItems.forEach(function (requestedItem) {
        var requestedProperties = requestedItem.properties || {};
        var requestedColor = String(requestedProperties['_Toy style'] || requestedProperties['Toy style'] || '');
        var requestedAddOn = String(requestedProperties['_Ruff add-on'] || '');
        var existingIndex = cart.items.findIndex(function (cartItem) {
          var cartProperties = cartItem.properties || {};
          if (Number(cartItem.variant_id) !== Number(requestedItem.id)) return false;
          if (requestedAddOn) return String(cartProperties['_Ruff add-on'] || '') === requestedAddOn;
          return !cartProperties['_Ruff add-on'] && cartItemColor(cartItem) === requestedColor;
        });

        if (existingIndex >= 0) {
          if (requestedAddOn) {
            if (Number(cart.items[existingIndex].quantity || 0) !== 1) {
              changes.push({ line: existingIndex + 1, quantity: 1 });
            }
          } else {
            changes.push({
              line: existingIndex + 1,
              quantity: Number(cart.items[existingIndex].quantity || 0) + Number(requestedItem.quantity || 0)
            });
          }
        } else {
          additions.push(requestedItem);
        }
      });

      function applyChange(index) {
        if (index >= changes.length) return Promise.resolve(finalResult);
        var includeSections = index === changes.length - 1 && additions.length === 0;
        return postCartChange(root, changes[index].line, changes[index].quantity, includeSections).then(function (result) {
          finalResult = result;
          return applyChange(index + 1);
        });
      }

      return applyChange(0).then(function () {
        if (!additions.length) return finalResult;
        return postCartAdd(root, additions).then(function (result) {
          finalResult = result;
          return finalResult;
        });
      });
    }).then(function () {
      return fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' } });
    }).then(function (response) {
      if (!response.ok) throw new Error('Unable to refresh your cart total.');
      return response.json();
    }).then(function (cart) {
      return {
        cart: cart,
        sectionHtml: finalResult && finalResult.sections ? finalResult.sections['annas-cart-drawer'] : ''
      };
    });
  }

  function initializeCartDrawer(root) {
    var drawer = root.matches && root.matches('[data-cart-drawer]') ? root : root.querySelector('[data-cart-drawer]');
    if (!drawer || drawer.dataset.ready) return;
    drawer.dataset.ready = 'true';
    var drawerMoneyFormat = drawer.dataset.moneyFormat || '${{amount}}';
    var drawerCurrency = drawer.dataset.presentmentCurrency || '';
    drawer.querySelectorAll('[data-money-cents]').forEach(function (node) {
      node.textContent = formatMoney(Number(node.dataset.moneyCents || 0), drawerMoneyFormat, drawerCurrency);
    });

    drawer.addEventListener('click', function (event) {
      if (drawer.classList.contains('isLoading')) return;
      var closeButton = event.target.closest('[data-cart-close]');
      if (closeButton) {
        if (closeButton.tagName !== 'A') event.preventDefault();
        closeAnnaCart();
        return;
      }

      var removeButton = event.target.closest('[data-cart-remove]');
      if (removeButton) {
        event.preventDefault();
        changeCartLine(drawer, removeButton.dataset.cartLine, 0);
        return;
      }

      var quantityButton = event.target.closest('[data-cart-delta]');
      if (!quantityButton || quantityButton.disabled) return;
      event.preventDefault();
      var item = quantityButton.closest('[data-item-quantity]');
      var current = Number(item ? item.dataset.itemQuantity : 1);
      var delta = Number(quantityButton.dataset.cartDelta || 0);
      changeCartLine(drawer, quantityButton.dataset.cartLine, Math.max(1, current + delta));
    });

    drawer.addEventListener('submit', function (event) {
      var checkoutForm = event.target.closest('[data-cart-checkout-form]');
      if (!checkoutForm) return;
      var orphanUpdates = orphanAddOnUpdates(drawer);
      if (!orphanUpdates) return;
      event.preventDefault();
      if (drawer.classList.contains('isLoading')) return;
      updateCartItems(drawer, orphanUpdates, true);
    });

    removeOrphanAddOns(drawer, drawer.classList.contains('isOpen'));
  }

  function initializeCartOpeners(root) {
    root.querySelectorAll('[data-cart-open]').forEach(function (opener) {
      if (opener.dataset.ready) return;
      opener.dataset.ready = 'true';
      opener.addEventListener('click', function (event) {
        if (!currentCartDrawer()) return;
        event.preventDefault();
        openAnnaCart();
      });
    });
  }

  function initializeStorefrontProtection() {
    if (document.documentElement.dataset.annaProtectionReady) return;
    document.documentElement.dataset.annaProtectionReady = 'true';

    window.addEventListener('contextmenu', function (event) { event.preventDefault(); });
    document.addEventListener('selectstart', function (event) { event.preventDefault(); });
    document.addEventListener('dragstart', function (event) {
      if (event.target && event.target.tagName === 'IMG') event.preventDefault();
    });
    document.addEventListener('keydown', function (event) {
      var key = String(event.key || '').toUpperCase();
      var command = event.ctrlKey || event.metaKey;
      var blocked = key === 'F12' || (command && event.shiftKey && ['I', 'J', 'C'].indexOf(key) >= 0) || (command && key === 'U');
      if (blocked) event.preventDefault();
      if (key === 'ESCAPE' && currentCartDrawer() && currentCartDrawer().classList.contains('isOpen')) closeAnnaCart();
      if (key === 'TAB' && currentCartDrawer() && currentCartDrawer().classList.contains('isOpen')) {
        var focusable = Array.from(currentCartDrawer().querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])'));
        if (!focusable.length) return;
        var first = focusable[0];
        var last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }
    });
  }

  window.AnnaCart = {
    open: openAnnaCart,
    close: closeAnnaCart,
    refresh: refreshAnnaCart,
    resetReservation: resetCartReservation
  };

  function initializeHeader(root) {
    var button = root.querySelector('[data-menu-button]');
    var nav = root.querySelector('[data-main-nav]');
    var stickyHeader = root.querySelector('[data-sticky-header]');
    if (!button || !nav || button.dataset.ready) return;
    button.dataset.ready = 'true';

    button.addEventListener('click', function () {
      var open = nav.classList.toggle('navOpen');
      button.setAttribute('aria-expanded', String(open));
    });

    nav.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function () {
        nav.classList.remove('navOpen');
        button.setAttribute('aria-expanded', 'false');
      });
    });

    if (stickyHeader && !stickyHeader.dataset.scrollReady) {
      stickyHeader.dataset.scrollReady = 'true';
      var lastScrollY = window.scrollY;
      var scrollQueued = false;

      window.addEventListener('scroll', function () {
        if (scrollQueued) return;
        scrollQueued = true;
        window.requestAnimationFrame(function () {
          var currentScrollY = window.scrollY;
          var scrollingDown = currentScrollY > lastScrollY;
          var menuOpen = nav.classList.contains('navOpen');
          stickyHeader.classList.toggle('headerHidden', scrollingDown && currentScrollY > stickyHeader.offsetHeight && !menuOpen);
          lastScrollY = currentScrollY;
          scrollQueued = false;
        });
      }, { passive: true });
    }
  }

  function initializeProduct(section) {
    if (section.dataset.ready) return;
    section.dataset.ready = 'true';

    var moneyFormat = section.dataset.moneyFormat || '${{amount}}';
    var presentmentCurrency = section.dataset.presentmentCurrency || '';
    section.querySelectorAll('[data-money-cents]').forEach(function (node) {
      node.textContent = formatMoney(Number(node.dataset.moneyCents || 0), moneyFormat, presentmentCurrency);
    });
    var jsonNode = section.querySelector('[data-product-json]');
    var product = null;
    if (jsonNode) {
      try { product = JSON.parse(jsonNode.textContent); } catch (error) { product = null; }
    }

    var gallery = section.querySelector('[data-gallery]');
    var viewport = section.querySelector('[data-gallery-viewport]');
    var track = section.querySelector('[data-gallery-track]');
    var images = Array.from(section.querySelectorAll('[data-gallery-image]'));
    var thumbs = Array.from(section.querySelectorAll('[data-gallery-thumb]'));
    var dotsWrap = section.querySelector('[data-gallery-dots]');
    var activePhoto = 0;
    var autoplay;

    if (gallery && viewport && track && images.length) {
      if (dotsWrap) {
        images.forEach(function (_, index) {
          var dot = document.createElement('span');
          dot.className = index === 0 ? 'dot activeDot' : 'dot';
          dotsWrap.appendChild(dot);
        });
      }

      var dots = dotsWrap ? Array.from(dotsWrap.children) : [];
      var showPhoto = function (index, smooth) {
        activePhoto = (index + images.length) % images.length;
        thumbs.forEach(function (thumb, thumbIndex) { thumb.classList.toggle('activeThumb', thumbIndex === activePhoto); });
        dots.forEach(function (dot, dotIndex) { dot.classList.toggle('activeDot', dotIndex === activePhoto); });

        if (window.matchMedia('(max-width: 700px)').matches) {
          viewport.scrollTo({ left: viewport.clientWidth * activePhoto, behavior: smooth === false ? 'auto' : 'smooth' });
        } else {
          track.style.transform = 'translate3d(-' + (activePhoto * 100) + '%,0,0)';
        }
      };

      var restartAutoplay = function () {
        window.clearInterval(autoplay);
        if (window.matchMedia('(max-width: 700px)').matches || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        autoplay = window.setInterval(function () { showPhoto(activePhoto + 1); }, 10000);
      };

      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () { showPhoto(Number(thumb.dataset.galleryThumb)); restartAutoplay(); });
      });
      var previous = section.querySelector('[data-gallery-previous]');
      var next = section.querySelector('[data-gallery-next]');
      if (previous) previous.addEventListener('click', function () { showPhoto(activePhoto - 1); restartAutoplay(); });
      if (next) next.addEventListener('click', function () { showPhoto(activePhoto + 1); restartAutoplay(); });

      var scrollFrame;
      viewport.addEventListener('scroll', function () {
        if (!window.matchMedia('(max-width: 700px)').matches) return;
        window.cancelAnimationFrame(scrollFrame);
        scrollFrame = window.requestAnimationFrame(function () {
          var index = Math.round(viewport.scrollLeft / Math.max(viewport.clientWidth, 1));
          if (index >= 0 && index < images.length) {
            activePhoto = index;
            thumbs.forEach(function (thumb, thumbIndex) { thumb.classList.toggle('activeThumb', thumbIndex === activePhoto); });
            dots.forEach(function (dot, dotIndex) { dot.classList.toggle('activeDot', dotIndex === activePhoto); });
          }
        });
      }, { passive: true });

      section.showAnnaPhoto = showPhoto;
      section.restartAnnaGalleryAutoplay = restartAutoplay;
      restartAutoplay();
    }

    var form = section.querySelector('.annasProductForm');
    if (!form) return;
    var isPlaceholder = form.hasAttribute('data-placeholder-purchase');
    if (isPlaceholder) {
      product = { title: '[Product name]', price: 0, variants: [0, 1, 2].map(function (index) {
        return { id: 0, title: '[Variant ' + (index + 1) + ']', price: 0, compare_at_price: 0, available: true, gallery_index: index };
      }) };
    }

    if (!product || typeof product !== 'object' || !Array.isArray(product.variants)) {
      var fallbackInput = section.querySelector('[data-fallback-variant]');
      product = {
        title: section.querySelector('.productInfo h1') ? section.querySelector('.productInfo h1').textContent.trim() : 'Dog Toy',
        price: Number(section.dataset.basePrice || 0),
        variants: [{
          id: fallbackInput ? Number(fallbackInput.value) : 0,
          title: 'Default Title',
          price: Number(section.dataset.basePrice || 0),
          compare_at_price: Number(section.dataset.comparePrice || 0),
          available: true,
          featured_image: null
        }]
      };
    }

    var fallbackImages = product.fallback_images || {};
    var variants = product.variants.filter(function (variant) { return variant.available !== false; });
    if (!variants.length) variants = product.variants;
    if (!variants.length) return;

    variants = variants.map(function (variant, index) {
      var galleryIndex = Number.isInteger(Number(variant.gallery_index)) ? Number(variant.gallery_index) : index;
      return Object.assign({}, variant, { _galleryIndex: galleryIndex % Math.max(images.length, 1) });
    });

    var bundleCards = Array.from(section.querySelectorAll('[data-bundle]'));
    var rows = section.querySelector('[data-variant-rows]');
    var inlineUpgrades = section.querySelector('[data-inline-upgrades]');
    var selectionArea = section.querySelector('[data-selection-area]');
    var mainPrice = section.querySelector('[data-main-price]');
    var mainCompare = section.querySelector('[data-main-compare]');
    var addButton = section.querySelector('[data-add-button]');
    var fallbackVariant = section.querySelector('[data-fallback-variant]');
    var fallbackQuantity = section.querySelector('[data-fallback-quantity]');
    var addOnInputs = Array.from(section.querySelectorAll('[data-addon]'));
    var initiallySelectedBundle = section.querySelector('.selectedBundle');
    var quantity = Number(initiallySelectedBundle ? initiallySelectedBundle.dataset.bundle : 2);
    var selections = [0, 1, 2].map(function (index) { return index % variants.length; });

    function variantImage(variant, index) {
      if (variant && variant._image) return variant._image;
      if (variant && variant.featured_image && variant.featured_image.src) return variant.featured_image.src;
      if (variant && variant.featured_image && typeof variant.featured_image === 'string') return variant.featured_image;
      if (variant && variant._fallbackImage) return variant._fallbackImage;
      var galleryIndex = variant && Number.isInteger(variant._galleryIndex) ? variant._galleryIndex : index;
      return images[galleryIndex % images.length] ? images[galleryIndex % images.length].src : '';
    }

    function selectedVariant(index) {
      return variants[Number(selections[index])] || variants[0];
    }

    function updatePrices() {
      var first = selectedVariant(0);
      function packTotals(count, percent, fixedDiscount) {
        var result = { price: 0, compare: 0 };
        percent = Math.min(95, Math.max(0, Number(percent || 0)));
        for (var index = 0; index < count; index += 1) {
          var variant = selectedVariant(index);
          var price = Number(variant.price || 0);
          // Shopify rounds each unit's percentage discount down to whole cents.
          result.price += price - Math.floor(price * percent / 100);
          result.compare += Math.max(price, Number(variant.compare_at_price || 0));
        }
        result.price = Math.max(0, result.price - Number(fixedDiscount || 0));
        return result;
      }
      var selectedCard = bundleCards.find(function (card) { return Number(card.dataset.bundle) === quantity; });
      var selectedPercent = Number(selectedCard ? selectedCard.dataset.discountPercent : 0);
      var totals = packTotals(quantity, selectedPercent, selectedCard ? selectedCard.dataset.discountAmount : 0);
      var total = totals.price;

      if (mainPrice) mainPrice.textContent = formatMoney(total, moneyFormat, presentmentCurrency);
      if (mainCompare) {
        var selectedCompare = totals.compare;
        mainCompare.textContent = selectedCompare > total ? formatMoney(selectedCompare, moneyFormat, presentmentCurrency) : '';
        mainCompare.hidden = selectedCompare <= total;
      }
      if (fallbackVariant) fallbackVariant.value = first.id;
      if (fallbackQuantity) fallbackQuantity.value = quantity;

      bundleCards.forEach(function (card) {
        var cardQuantity = Number(card.dataset.bundle);
        var cardPercent = Math.min(95, Math.max(0, Number(card.dataset.discountPercent || 0)));
        var cardTotals = packTotals(cardQuantity, cardPercent, card.dataset.discountAmount);
        var cardCompare = cardTotals.compare;
        var cardTotal = cardTotals.price;
        var cardSavings = Math.max(0, cardCompare - cardTotal);
        var price = card.querySelector('[data-bundle-price]');
        var regular = card.querySelector('[data-bundle-regular]');
        var savingsBadge = card.querySelector('[data-bundle-save]');
        if (price) price.textContent = isPlaceholder ? '[Price]' : formatMoney(cardTotal, moneyFormat, presentmentCurrency);
        if (regular) {
          regular.textContent = isPlaceholder ? '[Compare-at price]' : (cardCompare > cardTotal ? formatMoney(cardCompare, moneyFormat, presentmentCurrency) : '');
          regular.hidden = !isPlaceholder && cardCompare <= cardTotal;
        }
        if (savingsBadge) {
          savingsBadge.textContent = isPlaceholder ? '[Savings]' : ('SAVE ' + Math.round(cardSavings / Math.max(cardCompare, 1) * 100) + '%');
          savingsBadge.hidden = !isPlaceholder && cardSavings <= 0;
        }
      });
    }

    function renderRows() {
      var activeSlot = null;
      bundleCards.forEach(function (card) {
        var option = card.closest('[data-bundle-option]');
        var slot = option ? option.querySelector('[data-bundle-variant-slot]') : null;
        var selected = card.classList.contains('selectedBundle');
        card.setAttribute('aria-expanded', String(selected));
        if (option) option.classList.toggle('selectedBundleOption', selected);
        if (slot) {
          slot.hidden = !selected;
          if (selected) activeSlot = slot;
        }
      });
      if (activeSlot && rows.parentNode !== activeSlot) activeSlot.appendChild(rows);
      if (activeSlot && inlineUpgrades) {
        activeSlot.appendChild(inlineUpgrades);
        inlineUpgrades.hidden = false;
      }
      if (activeSlot && selectionArea) activeSlot.appendChild(selectionArea);
      rows.innerHTML = '';
      for (var index = 0; index < quantity; index += 1) {
        var variant = selectedVariant(index);
        var row = document.createElement('div');
        row.className = 'variantRow';

        var number = document.createElement('span');
        number.className = 'toyNumber';
        number.textContent = String(index + 1);

        var shell = document.createElement('label');
        shell.className = 'variantSelectShell';
        var image = document.createElement('img');
        image.src = variantImage(variant, index);
        image.alt = '';

        var copy = document.createElement('span');
        copy.className = 'variantSelectCopy';
        var label = document.createElement('span');
        label.className = 'variantSelectLabel';
        label.textContent = 'Toy ' + (index + 1);
        var select = document.createElement('select');
        select.setAttribute('aria-label', 'Choose toy style for item ' + (index + 1));

        variants.forEach(function (optionVariant, optionIndex) {
          var option = document.createElement('option');
          option.value = optionIndex;
          option.textContent = optionVariant.title === 'Default Title' ? product.title : optionVariant.title;
          option.selected = optionIndex === Number(selections[index]);
          select.appendChild(option);
        });

        (function (rowIndex, rowImage, rowSelect, rowShell) {
          rowSelect.addEventListener('change', function () {
            selections[rowIndex] = Number(rowSelect.value);
            var nextVariant = selectedVariant(rowIndex);
            rowImage.src = variantImage(nextVariant, rowIndex);
            updatePrices();

            if (section.showAnnaPhoto) section.showAnnaPhoto(nextVariant._galleryIndex);
            if (section.restartAnnaGalleryAutoplay) section.restartAnnaGalleryAutoplay();
          });
          rowShell.addEventListener('click', function (event) {
            if (event.target === rowSelect) return;
            event.preventDefault();
            rowSelect.focus();
            if (typeof rowSelect.showPicker === 'function') {
              try { rowSelect.showPicker(); } catch (error) {}
            } else {
              rowSelect.click();
            }
          });
        })(index, image, select, shell);

        copy.appendChild(label);
        copy.appendChild(select);
        shell.appendChild(image);
        shell.appendChild(copy);
        row.appendChild(number);
        row.appendChild(shell);
        rows.appendChild(row);
      }
      if (addButton) addButton.textContent = 'ADD TO CART';
      if (addButton) {
        var available = variants.some(function (variant) { return variant.available !== false; });
        addButton.disabled = isPlaceholder || !available;
        addButton.textContent = isPlaceholder ? '[Add to cart]' : (available ? 'ADD TO CART' : 'SOLD OUT');
      }
      updatePrices();
    }

    bundleCards.forEach(function (card) {
      card.addEventListener('click', function () {
        quantity = Number(card.dataset.bundle);
        bundleCards.forEach(function (other) {
          var selected = other === card;
          other.classList.toggle('selectedBundle', selected);
          other.setAttribute('aria-pressed', String(selected));
        });
        renderRows();
      });
    });

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (isPlaceholder || addButton.disabled) return;
      addButton.disabled = true;
      addButton.textContent = 'ADDING…';

      var groupedItems = {};
      selections.slice(0, quantity).forEach(function (selectionIndex) {
        var chosenVariant = variants[Number(selectionIndex)] || variants[0];
        var color = chosenVariant.title === 'Default Title' ? product.title : chosenVariant.title;
        var key = String(chosenVariant.id) + '|' + color;
        if (!groupedItems[key]) {
          groupedItems[key] = {
            id: Number(chosenVariant.id),
            quantity: 0,
            properties: {
              '_Toy style': color
            }
          };
        }
        groupedItems[key].quantity += 1;
      });
      var items = Object.keys(groupedItems).map(function (key) { return groupedItems[key]; });
      addOnInputs.forEach(function (input) {
        if (!input.checked || !input.dataset.addonId) return;
        items.push({
          id: Number(input.dataset.addonId),
          quantity: 1,
          properties: {
            '_Ruff add-on': input.dataset.addonKind || 'order-upgrade'
          }
        });
      });
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

      var cartAdded = false;
      addOrIncrementCartItems(root, items).then(function (result) {
        cartAdded = true;
        var cart = result.cart;
        updateCartCounts(cart);
        addButton.disabled = false;
        renderRows();
        resetCartReservation();
        if (result.sectionHtml) {
          renderCartDrawerSection(result.sectionHtml, true);
          return;
        }
        if (window.AnnaCart && window.AnnaCart.refresh) return window.AnnaCart.refresh(true);
        openAnnaCart();
      }).catch(function (error) {
        addButton.disabled = false;
        renderRows();
        if (cartAdded) openAnnaCart();
      });
    });

    renderRows();
  }

  function initializeProductReviewCarousels(root) {
    var carousels = [];
    if (root.matches && root.matches('[data-product-review-carousel]')) carousels.push(root);
    root.querySelectorAll('[data-product-review-carousel]').forEach(function (carousel) { carousels.push(carousel); });

    carousels.forEach(function (carousel) {
      if (carousel.dataset.reviewCarouselReady === 'true') return;
      carousel.dataset.reviewCarouselReady = 'true';

      var track = carousel.querySelector('[data-product-review-track]');
      var slides = Array.from(carousel.querySelectorAll('[data-product-review-slide]'));
      var dots = Array.from(carousel.querySelectorAll('[data-product-review-dot]'));
      var viewport = carousel.querySelector('.productReviewViewport');
      var activeIndex = 0;
      var touchStartX = null;
      if (!track || slides.length < 2) return;

      function showReview(index) {
        activeIndex = (Number(index) + slides.length) % slides.length;
        track.style.transform = 'translateX(-' + (activeIndex * 100) + '%)';
        slides.forEach(function (slide, slideIndex) {
          var active = slideIndex === activeIndex;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', String(!active));
        });
        dots.forEach(function (dot, dotIndex) {
          var active = dotIndex === activeIndex;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-selected', String(active));
          dot.setAttribute('tabindex', active ? '0' : '-1');
        });
      }

      function stopAutoplay() {
        window.clearInterval(carousel._annaReviewTimer);
      }

      function startAutoplay() {
        stopAutoplay();
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        carousel._annaReviewTimer = window.setInterval(function () {
          if (!carousel.isConnected) {
            stopAutoplay();
            return;
          }
          showReview(activeIndex + 1);
        }, 5200);
      }

      function chooseReview(index) {
        showReview(index);
        startAutoplay();
      }

      dots.forEach(function (dot) {
        dot.addEventListener('click', function () { chooseReview(Number(dot.dataset.productReviewDot)); });
      });

      carousel.addEventListener('mouseenter', stopAutoplay);
      carousel.addEventListener('mouseleave', startAutoplay);
      carousel.addEventListener('focusin', stopAutoplay);
      carousel.addEventListener('focusout', function () {
        window.setTimeout(function () {
          if (!carousel.contains(document.activeElement)) startAutoplay();
        }, 0);
      });

      if (viewport) {
        viewport.addEventListener('touchstart', function (event) {
          touchStartX = event.touches && event.touches[0] ? event.touches[0].clientX : null;
          stopAutoplay();
        }, { passive: true });
        viewport.addEventListener('touchend', function (event) {
          var endX = event.changedTouches && event.changedTouches[0] ? event.changedTouches[0].clientX : null;
          if (touchStartX !== null && endX !== null && Math.abs(endX - touchStartX) > 42) {
            showReview(activeIndex + (endX < touchStartX ? 1 : -1));
          }
          touchStartX = null;
          startAutoplay();
        }, { passive: true });
      }

      showReview(0);
      startAutoplay();
    });
  }

  function initializeTestimonialCarousels(root) {
    var carousels = [];
    if (root.matches && root.matches('[data-testimonial-carousel]')) carousels.push(root);
    root.querySelectorAll('[data-testimonial-carousel]').forEach(function (carousel) { carousels.push(carousel); });

    carousels.forEach(function (carousel) {
      if (carousel.dataset.testimonialCarouselReady === 'true') return;
      carousel.dataset.testimonialCarouselReady = 'true';

      var track = carousel.querySelector('[data-testimonial-track]');
      var slides = Array.from(carousel.querySelectorAll('[data-testimonial-slide]'));
      var dots = Array.from(carousel.querySelectorAll('[data-testimonial-dot]'));
      var previous = carousel.querySelector('[data-testimonial-prev]');
      var next = carousel.querySelector('[data-testimonial-next]');
      var activeIndex = 0;
      var scrollFrame = null;
      if (!track || slides.length < 2 || !previous || !next) return;

      function updateControls(index) {
        activeIndex = Math.max(0, Math.min(slides.length - 1, Number(index) || 0));
        dots.forEach(function (dot, dotIndex) {
          var active = dotIndex === activeIndex;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-selected', String(active));
          dot.setAttribute('tabindex', active ? '0' : '-1');
        });
        previous.disabled = activeIndex === 0;
        next.disabled = activeIndex === slides.length - 1;
      }

      function goTo(index, behavior) {
        index = Math.max(0, Math.min(slides.length - 1, Number(index) || 0));
        var slide = slides[index];
        var targetLeft = slide.offsetLeft - ((track.clientWidth - slide.offsetWidth) / 2);
        updateControls(index);
        track.scrollTo({ left: Math.max(0, targetLeft), behavior: behavior || 'smooth' });
      }

      function syncToScroll() {
        if (scrollFrame !== null) window.cancelAnimationFrame(scrollFrame);
        scrollFrame = window.requestAnimationFrame(function () {
          var trackCenter = track.scrollLeft + (track.clientWidth / 2);
          var nearestIndex = 0;
          var nearestDistance = Infinity;
          slides.forEach(function (slide, slideIndex) {
            var slideCenter = slide.offsetLeft + (slide.offsetWidth / 2);
            var distance = Math.abs(slideCenter - trackCenter);
            if (distance < nearestDistance) {
              nearestDistance = distance;
              nearestIndex = slideIndex;
            }
          });
          updateControls(nearestIndex);
          scrollFrame = null;
        });
      }

      previous.addEventListener('click', function () { goTo(activeIndex - 1); });
      next.addEventListener('click', function () { goTo(activeIndex + 1); });
      dots.forEach(function (dot) {
        dot.addEventListener('click', function () { goTo(Number(dot.dataset.testimonialDot)); });
      });
      track.addEventListener('scroll', syncToScroll, { passive: true });
      window.addEventListener('resize', function () {
        if (window.matchMedia('(max-width: 700px)').matches) goTo(activeIndex, 'auto');
      });

      updateControls(0);
    });
  }

  function initialize(root) {
    if (root === document && document.body.classList.contains('template-cart')) {
      queueCartOpenAfterReload();
      window.location.replace(storeRoot());
      return;
    }
    initializeStorefrontProtection();
    initializeHeader(root);
    initializeCartOpeners(root);
    initializeCartDrawer(root);
    if (root.matches && root.matches('[data-product-section]')) initializeProduct(root);
    root.querySelectorAll('[data-product-section]').forEach(initializeProduct);
    initializeProductReviewCarousels(root);
    initializeTestimonialCarousels(root);
    if (root === document && consumeCartOpenAfterReload()) window.setTimeout(openAnnaCart, 30);
  }

  initialize(document);
  document.addEventListener('shopify:section:load', function (event) { initialize(event.target); });
})();
